import React, {useRef} from 'react';
import PropTypes from 'prop-types';

const ItemCode = ({value, index, updateCode}) => {

    const ref = useRef(null);

    const onChange = () => {
        const next = ref.current.nextElementSibling;

        updateCode(ref.current.value.replace(/\D+/g, ''), index);
        if (next) {
            next.focus();
            next.select(false);
        } else ref.current.blur();
    };

    return (
        <input
            ref={ref}
            type="text"
            value={value}
            pattern="[0-9]*"
            onChange={onChange}
            onClick={() => ref.current.select(false)}
            className={`form-control code-input__item ${value.length ? 'done' : ''}`}
        />
    );
};

export default ItemCode;

ItemCode.propTypes = {
    value: PropTypes.string,
    index: PropTypes.number,
    updateCode: PropTypes.func
};